export const validateRHProfile = (values = {}) => {
  const errors = {};
  if (!values.firstName?.trim()) errors.firstName = 'Le prénom est requis.';
  if (!values.lastName?.trim()) errors.lastName = 'Le nom est requis.';
  if (values.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) errors.email = 'Adresse e-mail invalide.';
  return errors;
};

export const validateRHPassword = (values = {}) => {
  const errors = {};
  if (!values.currentPassword) errors.currentPassword = 'Le mot de passe actuel est requis.';
  if (!values.newPassword || values.newPassword.length < 8) errors.newPassword = '8 caractères minimum.';
  if (values.newPassword !== values.confirmPassword) errors.confirmPassword = 'Les mots de passe ne correspondent pas.';
  return errors;
};

export const validateRHAbsence = (values = {}) => {
  const errors = {};
  if (!values.type) errors.type = 'Sélectionnez un type d’absence.';
  if (!values.date_debut) errors.date_debut = 'La date de début est requise.';
  if (!values.date_fin) errors.date_fin = 'La date de fin est requise.';
  if (values.date_debut && values.date_fin && new Date(values.date_fin) < new Date(values.date_debut)) errors.date_fin = 'La fin doit être postérieure au début.';
  return errors;
};

export const hasRHValidationErrors = (errors = {}) => Object.values(errors).some(Boolean);
export const isRHFormValid = (values) => !hasRHValidationErrors(validateRHProfile(values));
